import { render, staticRenderFns } from "./CardexclusivePhone.vue?vue&type=template&id=324efc42&scoped=true&"
import script from "./CardexclusivePhone.vue?vue&type=script&lang=js&"
export * from "./CardexclusivePhone.vue?vue&type=script&lang=js&"
import style1 from "./CardexclusivePhone.vue?vue&type=style&index=1&id=324efc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324efc42",
  null
  
)

export default component.exports